import MappingTool from './MappingTool';
import './MappingTool.scss';

export default MappingTool;
